import { render, staticRenderFns } from "./UITable.vue?vue&type=template&id=48b810bb&scoped=true"
import script from "./UITable.vue?vue&type=script&lang=js"
export * from "./UITable.vue?vue&type=script&lang=js"
import style0 from "./UITable.vue?vue&type=style&index=0&id=48b810bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b810bb",
  null
  
)

export default component.exports